import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import SlackConfirmPage from "@/pages/slack/SlackConfirmPage";

const searchSchema = z.object({
  slack_team_id: z.coerce.string(),
  app_id: z.coerce.string(),
});

export const Route = createFileRoute("/_secure/slack/confirm")({
  validateSearch: zodValidator(searchSchema),
  component: RouteComponent,
});

function RouteComponent() {
  return <SlackConfirmPage />;
}
